<p-tabView [(activeIndex)]="index" (onChange)="getIndex($event)">
    <p-tabPanel header="Sub Modules">
        <app-orders-type
            [ordersSubmoduleTypeId]="ordersSubmoduleTypeId"
            [ordersSubmoduleConfig]="ordersSubmoduleConfig"
            [allOrderSubmodule]="allOrderSubmodule"
        ></app-orders-type>
    </p-tabPanel>
    <!-- <p-tabPanel header="Status">
        <app-orders-status
            [ordersStatusTypeId]="ordersStatusTypeId"
            [ordersStatusConfig]="ordersStatusConfig"
            [allOrderStatus]="allOrderStatus"
        ></app-orders-status>
    </p-tabPanel> -->
    <p-tabPanel header="Template">
        <app-orders-template
            [ordersTemplateTypeId]="ordersTemplateTypeId"
            [allOrderTemplates]="allOrderTemplates"
            [ordersTemplateConfig]="ordersTemplateConfig"
            [ordersSectionTypeId]="ordersSectionTypeId"
        ></app-orders-template>
    </p-tabPanel>
    <p-tabPanel header="Fields">
        <app-order-fields
            [allOrderFullfillmentStatus]="allOrderFullfillmentStatus"
            [ordersFullfillmentConfig]="ordersFullfillmentConfig"
            [allOrderBackOrderStatus]="allOrderBackOrderStatus"
            [ordersBackOrderConfig]="ordersBackOrderConfig"
        ></app-order-fields>
    </p-tabPanel>
    <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
        <ng-template pTemplate="header">
            <p-menu
                #configmenuOrders
                id="config_menu_orders"
                [model]="configMenuOrdersItems"
                [popup]="true"
                appendTo="body"
            >
            </p-menu>
            <span
                class="btnBars p-mr-0"
                (click)="configmenuOrders.toggle($event)"
            >
                <i class="pi pi-bars"></i>
            </span>
        </ng-template>
    </p-tabPanel>
</p-tabView>
